import React, { useRef } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { Button } from "@mui/material";
import { MdOutlineSaveAlt } from "react-icons/md";

const ReportList = ({ reports, filteredReports, currentItems }) => {
  const tableRef = useRef(null);
  const formatDateTime = (date) => {
    const dateTime = new Date(date);
    const formattedDate = dateTime.toLocaleDateString();
    const formattedTime = dateTime.toLocaleTimeString();
    return { formattedDate, formattedTime };
  };
  const handleExportExcel = () => {
    const excelData = currentItems.map((report, index) => ({
      "#": index + 1,
      "Customer Name": `${report.firstName} ${report.lastName}`,
      "Shared Number": report.referralMobile,
      "Product Name": report.productName,
      "Claim Balance": report.claimBalance,
      Date: report.formattedDate,
      Time: report.formattedTime,
      Status: report.remarks === "verified" ? "Verified" : report.remarks,
    }));

    const headers = [
      "#",
      "Customer Name",
      "Shared Number",
      "Product Name",
      "Claim Balance",
      "Date",
      "Time",
      "Status",
    ];

    
  };
  return (
    <div>
      <div className="mb-4 mt-2 flex justify-end">
        <DownloadTableExcel
          filename="report"
          sheet="report"
          currentTableRef={tableRef.current}
        >
          <Button
            variant="contained"
            color="primary"
            startIcon={<MdOutlineSaveAlt />}
            onClick={handleExportExcel}
          >
            Download Excel
          </Button>
        </DownloadTableExcel>
      </div>
      <div className="overflow-x-auto">

      <table className="min-w-full divide-y divide-gray-200" ref={tableRef}>
        <thead className="bg-gray-50">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              #
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Customer Name
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Settled Amount
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Account Details
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Date
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Time
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {currentItems.map((report, index) => {
            const { formattedDate, formattedTime } = formatDateTime(
              report.date
            );
            return (
              <tr key={index}>
                <td className="px-4 py-4 whitespace-nowrap">{index + 1}</td>
                <td className="px-4 py-4 whitespace-nowrap">
                  {report.firstName} {report.lastName}
                </td>
                <td className="px-4 py-4 whitespace-nowrap">
                  {report.settlementAmount}
                </td>
                <td className="px-4 py-4 whitespace-nowrap">
                  {report.accountDetails.length > 0 && (
                    <div>
                      <p>Bank Name: {report.accountDetails[0].bankName}</p>
                      <p>
                        Account Number: {report.accountDetails[0].accountNumber}
                      </p>
                      <p>IFSC Code: {report.accountDetails[0].ifscCode}</p>
                    </div>
                  )}
                </td>

                <td className="px-4 py-4 whitespace-nowrap">{formattedDate}</td>
                <td className="px-4 py-4 whitespace-nowrap">{formattedTime}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default ReportList;
